<template>
  <div v-if="statuList.length>0" class="custom-flex-space-between w100 milestone">
    <div v-for="(item, index) in statuList" :key="index" class="custom-flex-space-between" :class="index<statuList.length-1?'w100':''">
      <div class="node custom-flex-center" :class="item.EventDT?'nodeActivate':''">
        <!-- <div class="div-svg" :style="item.DivsvgStyle">
          <img :src="item.Img" :class="item.EventDT?'svg-icon':''" width="100%">
        </div> -->
        <div class="div-value">
          <div v-if="imgLayout==='top'" class="div-img" :style="item.DivsvgStyle">
            <img :src="item.EventDT?item.OpenImg:item.ShutImg">
          </div>
          <p>{{ item.Name }}</p>
          <div> {{ item.EventDT }}</div>
          <div v-if="imgLayout==='bottom'" class="div-img" :style="item.DivsvgStyle">
            <img :src="item.EventDT?item.OpenImg:item.ShutImg">
          </div>
        </div>
      </div>
      <div v-if="index<statuList.length-1" class="custom-flex-center line" :class="item.EventDT?'lineActivate':''">
        <div class="lineLeft" />
        <!-- <i class="el-icon-caret-right lineRight" /> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    statuList: {
      type: Array,
      default: () => []
    },
    imgLayout: {
      type: String,
      default: 'top'
    }
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>
.w100 {
  width: 100%;
}
.node {
  width: 130px;
  color: #9ca3af;
}
.nodeActivate {
  color: #111827;
  font-weight: 600;
}
.line {
  width: calc(100% - 130px);
  color: #e9ecf2;
}
.lineActivate {
  color:  #67b0c4;
}
.lineLeft {
  padding-left: 10%;
  width: 100%;
  /* border-top: 2px dashed; */
  border-top: 1px solid;
}
.div-svg {
  width: 60px;
  height: 60px;
  display: flex;
  overflow: hidden;
}
.div-value {
  width: calc(100% - 0px);
  text-align: center;
}
.svg-icon {
  position: relative;
  left: -80px;
  filter: drop-shadow(#3809f3 80px 0);
}
.div-img{
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}
.div-img img {
  width: 28px;
  height: 28px;
}
.milestone{
  height: 109px;
  padding: 21px 50px 15px 21px;
  background: #f3f8fa;
  margin-top: 19px;
}

</style>
